<template lang='pug'>
  v-container.fill-height
    v-row( justify='center' align='center')
      v-col( cols=12 md=4)
        v-card
          v-card-title Iniciar sesión
          v-card-text
            v-text-field( label='Correo' v-model='correo_electronico')
            v-text-field( label='Contraseña' type='password' v-model='contraseña')
          v-card-actions
            v-spacer
            v-btn( rounded outlined @click='iniciar_sesion({correo_electronico, contraseña})' ) Entrar

</template>
<script>
import {mapActions} from 'vuex'
export default {
  data: ()=>({
    correo_electronico: '',
    contraseña: '',
  }),
  methods: {
    ...mapActions({
      iniciar_sesion: 'Sesion/iniciar_sesion'
    })
  }
}
</script>